import { createSlice } from "@reduxjs/toolkit";
import { fetchFaqsHistoryItems } from "./FaqshistoryThunks";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const faqsHistorySlice = createSlice({
  name: "faqshistory",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchFaqsHistoryItems.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFaqsHistoryItems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchFaqsHistoryItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default faqsHistorySlice.reducer;